import React from 'react';
import { MobileLayout } from '../../components/MobileLayout';
import { Card, CardContent } from '../../components/ui/Card';
import { Users, CheckCircle, Wallet, Settings, Construction } from 'lucide-react';
type PlaceholderKind = 'team' | 'qualita' | 'guadagni' | 'impostazioni';
const config: Record<PlaceholderKind, {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
}> = {
  team: {
    title: 'Team',
    subtitle: 'Gestisci i tuoi cleaner, disponibilità e zone coperte',
    icon: <Users size={28} className="text-coral" data-id="element-2728" />
  },
  qualita: {
    title: 'Qualità',
    subtitle: 'Revisione dei punteggi CleanAI e dei controlli prima/dopo',
    icon: <CheckCircle size={28} className="text-coral" data-id="element-2729" />
  },
  guadagni: {
    title: 'Guadagni',
    subtitle: 'Incassi per intervento, payout ai cleaner e riepiloghi',
    icon: <Wallet size={28} className="text-coral" data-id="element-2730" />
  },
  impostazioni: {
    title: 'Impostazioni',
    subtitle: 'Profilo, zone operative e tariffe',
    icon: <Settings size={28} className="text-coral" data-id="element-2731" />
  }
};
export function CmPlaceholderPage({
  kind
}: {
  kind: PlaceholderKind;
}) {
  const c = config[kind];
  return <MobileLayout data-id="element-2732">
      <div className="mb-6" data-id="element-2733">
        <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-2734">{c.title}</h1>
      </div>

      <Card data-id="element-2735">
        <CardContent className="p-8 lg:p-12 text-center" data-id="element-2736">
          <div className="w-16 h-16 rounded-2xl bg-coral/10 flex items-center justify-center mx-auto mb-4" data-id="element-2737">
            {c.icon}
          </div>
          <h2 className="text-base font-bold text-navy mb-2 flex items-center justify-center gap-2" data-id="element-2738">
            <Construction size={18} className="text-muted-foreground" data-id="element-2739" />
            In arrivo
          </h2>
          <p className="text-sm text-muted-foreground max-w-sm mx-auto" data-id="element-2740">
            Questa sezione della piattaforma Cleaner Manager sarà disponibile a
            breve.
          </p>
        </CardContent>
      </Card>
    </MobileLayout>;
}